import { generateId } from '../helpers/generateId';
import { getCookie } from '../helpers/getCookie';

export const getRidAnmId = () => {
  let ridAnmId = localStorage.getItem('_rid_anm_id');

  if (!ridAnmId) {
    ridAnmId = getCookie('_rid_anm_id') || null;
  }

  if (!ridAnmId) {
    ridAnmId = '0000' + generateId(28);
  }

  return ridAnmId?.trim().replace(/%22/g, '').replace(/"/g, '');
};

export default getRidAnmId;
